import { css } from 'styled-components';
export var statuses = {
  success: /*#__PURE__*/css(["color:var(--plasma-field-success-color);"]),
  warning: /*#__PURE__*/css(["color:var(--plasma-field-warning-color);"]),
  error: /*#__PURE__*/css(["color:var(--plasma-field-error-color);"])
};